import axios from 'axios'
import { url } from '../../api/url'
import { HeadersWithCredentials } from '../../api/header'

export const IsPublished = async (eventIdentifier) => {
    return await axios.get(`${url}/leaderboard/is-published/${eventIdentifier}`, {
        headers: HeadersWithCredentials(),
    })
}

export const formatWodCap = (score) => {
    const newScore = []
    score.split('').map((nb, index) => {
        if (
            !(
                (score.split('')[0] === '0' && score.split('')[1] === '0' && (index === 0 || index === 1)) ||
                (score.split('')[6] === '0' && score.split('')[7] === '0' && (index === 6 || index === 7))
            )
        ) {
            newScore.push(nb)
            if (
                index === 1 ||
                index === 3 ||
                (index === 5 && !(score.split('')[6] === '0' && score.split('')[7] === '0'))
            )
                newScore.push(':')
        }
    })
    return newScore
}

export const formatScoreTime = (num, timeLength) => {
    const time = num.split('')
    return time.map((nb, indexT) => {
        if (timeLength.length >= 4 && (indexT === 2 || indexT === 3 || indexT === 4 || indexT === 5)) {
            if (indexT === 3) nb += ':'
            if (indexT === 5 && ((timeLength.length >= 5 && timeLength.hour === false) || timeLength.length >= 7))
                nb += '.'
            return nb
        }
        if (
            (indexT === 6 || indexT === 7) &&
            ((timeLength.length >= 5 && timeLength.hour === false) || timeLength.length >= 7)
        ) {
            return nb
        }
        if (
            (indexT === 0 || indexT === 1) &&
            ((timeLength.length >= 5 && timeLength.hour === true) || timeLength.length >= 7)
        ) {
            if (indexT === 1) nb += ':'
            return nb
        }
    })
}

/** Competition-level flags of the leaderboard (legacy raw fetch `PUT /leaderboard/competition/:id`, e.g. `{ public_video }`). */
export const updateCompetitionFlags = async (competitionId, body) => {
    return await axios.put(`${url}/leaderboard/competition/${competitionId}`, body, {
        headers: HeadersWithCredentials(),
    })
}

/** Custom score type (legacy `addScoreType/AddScoreType.jsx` raw fetch): `{ name, suffix, compared: 'ascending' | 'descending', rankType: 'all' }`. */
export const insertNewScoreType = async (orgaId, competitionId, body) => {
    return await axios.put(`${url}/leaderboard/competition/insertNewScoreType/${orgaId}/${competitionId}`, body, {
        headers: HeadersWithCredentials(),
    })
}

/** Delete a custom score type (legacy `HeadWOD.jsx` raw fetch). */
export const deleteScoreType = async (orgaId, competitionId, scoreTypeId) => {
    return await axios.delete(`${url}/leaderboard/scoreType/delete/${orgaId}/${competitionId}/${scoreTypeId}`, {
        headers: HeadersWithCredentials(),
    })
}
